var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIc1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9996 26.9886C39.5846 18.6386 37.8063 10.3586 33.0763 7.45698C28.6063 4.71532 24.7046 5.82032 22.3613 7.58032L20.638 8.87032M32.9996 26.9886C31.4196 28.9936 29.358 31.0003 26.738 32.9387C24.163 34.847 22.8746 35.8003 20.638 35.8003C18.4013 35.8003 17.1146 34.847 14.538 32.9387C1.00796 22.9253 2.33463 11.0553 8.19963 7.45698C12.6696 4.71532 16.5713 5.82032 18.9146 7.58032L20.638 8.87032M32.9996 26.9886L23.7913 16.542C23.6085 16.3353 23.3583 16.2001 23.0852 16.1604C22.812 16.1207 22.5337 16.1792 22.2996 16.3253L18.6563 18.602C17.9418 19.054 17.0802 19.2122 16.2518 19.0434C15.4233 18.8747 14.6922 18.3922 14.2115 17.6967C13.7307 17.0013 13.5375 16.1469 13.6723 15.3122C13.807 14.4776 14.2594 13.7274 14.9346 13.2187L20.638 8.87032",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc1);
export default __webpack_public_path__ + "static/media/ic1.0178ed46c58dbd9efd74ff0d5de72fff.svg";
export { ForwardRef as ReactComponent };